import type { JSX } from 'react';
import type { FieldValues } from 'react-hook-form';

import type { FormFieldProps } from '~/chords/FormField';
import { FormFieldDropdownTreeSingleSelect as ChordsFormFieldDropdownTreeSingleSelect } from '~/chords/FormField';
import type { DropdownTreeSingleSelectProps } from '~/components/DropdownTreeSingleSelect/DropdownTreeSingleSelect';
import type { ContainerComponentProps } from '~/components/WithClassNameHoc';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

type FormFieldDropdownTreeSingleSelectProps<
  TOptionProps,
  TFormFields extends FieldValues,
> = Omit<FormFieldProps<TFormFields>, 'children'> &
  Omit<
    DropdownTreeSingleSelectProps<TOptionProps>,
    'name' | 'className' | 'value' | 'onValueChange'
  > & {
    onValueChange?: (value: string) => void;
  };

export const FormFieldDropdownTreeSingleSelect = withClassNameHoc(
  ChordsFormFieldDropdownTreeSingleSelect,
) as <TOptionProps = unknown, TFormFields extends FieldValues = FieldValues>(
  props: ContainerComponentProps<
    FormFieldDropdownTreeSingleSelectProps<TOptionProps, TFormFields>
  >,
) => JSX.Element;
